import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AgilityRiskNavigationService } from '../../../providers/agility-risk-navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-risk-breadcrumb',
  templateUrl: './risk-breadcrumb.component.html',
  styleUrls: ['./risk-breadcrumb.component.scss']
})
export class RiskBreadcrumbComponent implements OnInit, OnDestroy {
  public home: MenuItem = {icon: 'pi pi-home', routerLink: '/', label: 'Home'}; // TODO: inject true home url here
  public items: Array<MenuItem> = [];
  private baseAddress = '/';
  private onNavigationChangedSubscription: Subscription;

  constructor(private navigationService: AgilityRiskNavigationService,
              private translateService: TranslateService) {
    if (navigationService.moduleBaseAddress) {
      this.baseAddress = navigationService.moduleBaseAddress;
      this.home.routerLink = navigationService.appHomeAddress;
    }
  }

  ngOnInit(): void {
    this.setBreadCrumb();
    this.onNavigationChangedSubscription = this.navigationService.onNavigationChanged().subscribe(_ => {
      this.setBreadCrumb();
    });
  }

  ngOnDestroy(): void {
    this.onNavigationChangedSubscription.unsubscribe();
  }

  setBreadCrumb() {
    this.items = [];
    this.navigationService.navigationHistory.forEach(n => {
      this.items.push({routerLink: n.url, label: this.translateService.instant(`route.${n.key}`)});
    });
  }
}
